// @flow

import React, {useState} from "react";
import GoogleMapReact from "google-map-react";
import {Input} from "antd";
import {useTranslation} from "react-i18next";

import {MapContainer, FormItem, Marker, DisableMapContainer} from "./SingleMarkerMapStyles";
import {singleMarkerMapPropType} from "./SingleMarkerMapPropTypes";
import apiKey from "../../../_core/apiKey";

export const SingleMarkerMap = ({
    icon,
    onClick,
    center,
    addExternalInput,
    customButton,
    disabled
}: singleMarkerMapPropType) => {
    const {t, i18n} = useTranslation(["singleMarkerMap"]);
    const [errorMessage, setErrorMessage] = useState("");
    return (
        <div data-testid="singleMapMarker">
            {disabled && <DisableMapContainer data-testid="disableMap" />}
            <MapContainer disabled={disabled} data-testid="map">
                <GoogleMapReact
                    bootstrapURLKeys={{
                        key: apiKey,
                        language: i18n.resolvedLanguage || "tr"
                    }}
                    heatmapLibrary={true}
                    center={center}
                    zoom={15}
                    onClick={onClick && !disabled ? onClick : () => {}}
                    options={{
                        fullscreenControl: true,
                        gestureHandling: "greedy"
                    }}
                >
                    <Marker data-testid="marker" icon={icon} lat={center.lat} lng={center.lng} />
                </GoogleMapReact>
                {customButton}
            </MapContainer>

            {addExternalInput && (
                <FormItem help={errorMessage} validateStatus={errorMessage ? "warning" : "success"}>
                    <Input
                        disabled={disabled}
                        placeholder={t("singleMarkerMap.addExternalInput", {ns: "singleMarkerMap"})}
                        data-testid="addExternalInput"
                        onChange={event => {
                            setErrorMessage("");
                            const {value: address} = event.target;
                            const matchedAddress = address.match(
                                /dir\/([0-9.\,])+\/|@([0-9.])+\,([0-9.])+/g
                            );
                            const location = matchedAddress
                                ? matchedAddress[0].match(/[0-9.]+[0-9.]+/g)
                                : null;
                            if (location && location.length > 1) {
                                onClick({
                                    lat: parseFloat(location[0]),
                                    lng: parseFloat(location[1])
                                });
                            } else {
                                setErrorMessage(
                                    address
                                        ? t("singleMarkerMap.externalInputError", {
                                              ns: "singleMarkerMap"
                                          })
                                        : ""
                                );
                            }
                        }}
                    />
                </FormItem>
            )}
        </div>
    );
};
